<template>
  <aside id="shop-sidebar" class="shop-sidebar">
    <div class="top">
      <p>{{ trans.cart }}</p>
      <span class="close" @click="handleClose"></span>
    </div>

    <div class="products">
      <ul class="list">
        <li
          v-for="cart in client_cart"
          :key="cart.variant_id"
          :data-card_id="cart.id"
        >
          <ProductListElement
            v-bind:product_data="cart"
            v-on:change_quantity="handleCartQuantity"
            v-on:remove_cart="handleRemoveCart"
          />
        </li>
      </ul>

      <div class="summary">
        <p>
          {{ trans.total_cost }}: <span>{{ total_price }} zł</span>
        </p>
      </div>
    </div>

    <div class="bottom">
      <a class="" @click="handleClose">{{ trans.continue_shopping }}</a>
      <button @click="handleOrder">{{ trans.buy }}</button>
    </div>
  </aside>
</template>

<script>
import ProductListElement from "@/components/ProductListElement.vue";

export default {
  name: "ShopBar",
  data() {
    return {
      state: "close",
      //client_cart: window.APP_INFO.init.client_cart,
      total_price: 0,
      trans: {
        continue_shopping: window.APP_INFO.trans.continue_shopping,
        buy: window.APP_INFO.trans.buy,
        cart: window.APP_INFO.trans.cart,
        total_cost: window.APP_INFO.trans.total_cost,
      },
    };
  },
  props: {
    cart_updated: {
      type: Number,
      required: true,
    },
    client_cart: {
      type: Array,
      required: false,
    },
  },
  /*watch: {
            client_cart: function (val) {
                console.log('watch')
                console.log(val)
                this.client_cart = val;
            },

        },*/
  components: {
    ProductListElement,
  },
  methods: {
    handleClose(e) {
      //e.preventDefault();
      this.$emit("close_sidebar");
    },
    handleOrder(e) {
      this.$emit("shoplo_checkout_action");
    },
    handleRemoveCart(e) {
      console.log(e);
      this.$emit("shoplo_remove_cart", { cart_id: e.cart_id });
    },
    updateTotalPrice() {
      let i;
      let total_price = 0;
      for (i = 0; i < this.client_cart.length; i++) {
        total_price +=
          parseInt(this.client_cart[i]["price"], 10) *
          parseInt(this.client_cart[i]["quantity"], 10);
      }
      this.total_price = parseFloat(total_price / 100).toFixed(2);
    },
    handleCartQuantity(e) {
      console.log(e);
      let i;
      for (i = 0; i < this.client_cart.length; i++) {
        if (this.client_cart[i].id == e.cart_id) {
          this.client_cart[i].quantity = e.quantity;
          break;
        }
      }
      this.updateTotalPrice();
      this.$emit("shoplo_update_cart", {
        cart_id: e.cart_id,
        quantity: e.quantity,
      });
    },
  },
  updated() {
    this.updateTotalPrice();
    console.log("shopbar updated");
    console.log(this.client_cart);
    //console.log(this.client_cart[0])
  },
  created() {
    console.log(this.client_cart.length);
    /*let i;
            let total_price = 0;
            for (i = 0; i < window.APP_INFO.init.client_cart.length; i++) {
                total_price += parseInt(window.APP_INFO.init.client_cart[i]['price'], 10);
            }
            this.total_price = total_price;*/
    this.updateTotalPrice();
    //console.log(window.APP_INFO.init.client_cart)
  },
};
</script>